export const meta = {
  id: 'iterative-deepening-dfs',
  name: 'Iterative Deepening DFS',
  category: 'Graph',
  complexity: {
    time: 'O(b^d)',
    space: 'O(d)'
  },
  description: 'Iterative Deepening DFS combines the space efficiency of DFS with the completeness of BFS by repeatedly running depth-limited DFS with increasing depth limits.'
};
